import type { DateRange, GroupBy } from '../types'

export const getGroupBy = (dateRange?: DateRange): GroupBy => {
  if (!dateRange) return { groupBy: 'date', groupByTitle: 'Day' }

  const beforeDate = dateRange.before ?? new Date()
  const afterDate = dateRange.after ?? new Date()

  const daysDifference =
    beforeDate && afterDate
      ? (beforeDate.getTime() - afterDate.getTime()) / (1000 * 60 * 60 * 24)
      : 0

  return {
    groupBy: daysDifference < 4 ? 'hour' : 'date',
    groupByTitle: daysDifference < 4 ? 'Hour' : 'Day',
  }
}
